<template>
  <div :class="classes">
    <pt-page-title title="医院管理" isSearch @search="search" @emptySearch="emptySearch" placeholder="请输入医院名称搜索"
      :searchKey="searchKey" @searchNo="searchNo" isParams>
      <template slot="before-left">
        <el-button type="primary" @click="createCompany">创建医院</el-button>
      </template>
    </pt-page-title>
    <pt-page-factor-filter :labels="HospitalTable" v-model="params" isQueryRouter ref="filter" @Filter="filter">
      <el-button type="primary" @click="filter()">筛选</el-button>
      <el-button type="text" @click="cleanParams">清除筛选条件</el-button>
    </pt-page-factor-filter>
    <pt-hospital-table :tableLabels="tableLabels" :isFromRouter="isFromRouter" ref="table" :paramsData="paramsData"
      :class="$style['pt-hospital-table']">
      <el-table-column label="操作">
        <template slot-scope="scope">
          <i class="iconfont icon-xiangqing" @click="goDetail(scope.row)"></i>
          <i class="iconfont icon-bianji" @click="goEdit(scope.row)"></i>
          <i class="iconfont icon-shanchu" @click="goDelete(scope.row)"></i>
        </template>
      </el-table-column>
    </pt-hospital-table>
  </div>
</template>

<script>
import {
  HospitalTableLabels,
  HospitalTable
} from '../hospital-and-doctor-manage'
import ptHospitalTable from './pt-hospital-table/withData'
import {
  emptyObject
} from '@/utils/lifebankUtils' // 组件class前缀
const prefixCls = 'pt-hospital-manage'

export default {
  name: 'pt-hospital-manage',
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  components: {
    ptHospitalTable
  },
  props: {
    companyList: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data () {
    return {
      HospitalTable: HospitalTable,
      tableLabels: HospitalTableLabels,
      params: {},
      paramsData: {},
      isFromRouter: false,
      searchKey: null
    }
  },
  watch: {
    companyList: {
      handler: function (val) {
        this.HospitalTable.forEach(item => {
          if (item.value === 'branchId') {
            item.options = val
          }
        })
      }
    }
  },
  methods: {
    search (val) {
      this.searchKey = val
      this.isFromRouter = false
      emptyObject(this.queryParams)
      emptyObject(this.params)
      this.paramsData = {
        searchKey: val
      }
    },
    emptySearch () {
      this.searchKey = null
      this.$delete(this.paramsData, 'searchKey')
    },
    searchNo (val) {
      this.searchKey = val
    },
    getTableData () {
      this.$refs.table.getTableData()
    },
    filter (isFromRouter) {
      this.isFromRouter = isFromRouter
      this.paramsData = {
        ...this.params
      }
      if (!isFromRouter) {
        this.$refs.filter.getAddRouter(this.paramsData)
      }
    },
    cleanParams () {
      for (var key in this.paramsData) {
        this.$delete(this.paramsData, key)
      }
      for (var key1 in this.params) {
        this.$delete(this.params, key1)
      }
    },
    goEdit (val) {
      this.$router.push('/hospital-manage/hospital-form/true/' + val.id)
    },
    goDelete (val) {
      this.$confirm('您确定删除该医院吗？', '删除医院', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(_ => {
        this.$emit('deleteHospital', val.id)
      })
    },
    goDetail (val) {
      this.$router.push('./hospital-detail/' + val.id)
    },
    createCompany () {
      this.$router.push('/hospital-manage/hospital-form/false/0')
    }
  }
}

</script>

<style module lang="less">
  /* 已启用css module， template中请使用$style.className添加class */
  /* 务必遵循css BEM原则 */
  .pt-hospital-table {
    :global .iconfont {
      margin-right: 10px;
    }
  }

</style>
